<mat-expansion-panel [expanded]="false" style="background-color: #f5cc94">
  <mat-expansion-panel-header>
    <strong>{{getTitleContact(hasRoleForEditContactAsync() | async)}}</strong>
  </mat-expansion-panel-header>
  <mat-panel-description>
    Un contact aura les mêmes droits que le demandeur. Il pourra modifier, suivre, envoyer la demande.
  </mat-panel-description>
  <mat-card-content fxLayout="column">
    <form fxLayout="column" *ngIf="ownerOrContactCanEditContacts() || (hasRoleForEditContactAsync() | async)">
      <app-search-ldap fxFlex="70" [ldapDisplayProperty]="'cn,mail'"
                       [removeDiatrics]="true"
                       [titleLabel]="'Ajout de contact'"
                       [placeHolder]="'Rechercher une personne dans l\'annuaire puis la sélectionner pour l\'ajouter...'"
                       [scope]="true"
                       [title]="false"
                       [defaultScopes]="'employee'"
                       [scopesToDisplay]="['employee', 'faculty', 'researcher']"
                       (ldapUserSelected)="onSelectContact($event)">
      </app-search-ldap>
    </form>
  </mat-card-content>
  <mat-card-content>
    <mat-chip-listbox>
      <mat-chip *ngFor="let contact of dossier?.contacts_obj" removable>
        <span>{{contact.last_name}} {{contact.first_name}} ({{contact.uid}})</span>
        <span>&nbsp;{{contact.email_pro}}</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="deleteContact(contact)"
                *ngIf="ownerOrContactCanEditContacts() || (hasRoleForEditContactAsync() | async)">
          <mat-icon class="mat-16">close</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-listbox>
  </mat-card-content>
</mat-expansion-panel>
